import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import { useLocation } from "react-router-dom";

const Login = () => {
  const location = useLocation();
  const error = location.state?.error;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    // Best-effort: request Google's account-chooser instead of silent auto-login.
    // Emergent's auth wrapper may or may not forward this to Google.
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}&prompt=select_account`;
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-sm overflow-hidden">
        <div className="bg-slate-900 px-6 py-8 text-white flex items-center gap-3">
          <div className="h-12 w-12 bg-white flex items-center justify-center rounded-sm p-1 shrink-0">
            <img src="/sre-logo.webp" alt="SR Electrosteel" className="h-full w-full object-contain" />
          </div>
          <div>
            <p className="text-[10px] tracking-[0.25em] uppercase text-slate-400 font-semibold leading-none">Enterprise Resource Planning</p>
            <h1 className="font-heading text-xl font-bold tracking-tight mt-1">SR ELECTROSTEEL PRIVATE LIMITED</h1>
          </div>
        </div>
        <div className="p-6 space-y-5">
          <div>
            <p className="text-[10px] tracking-[0.25em] uppercase text-slate-500 font-semibold mb-1">Sign in</p>
            <h2 className="font-heading text-2xl font-bold text-slate-900">Use your company Google ID</h2>
            <p className="text-sm text-slate-600 mt-2">
              Access is restricted to authorised users only. New sign ups will be approved by management.
            </p>
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm bg-red-50 border border-red-200 rounded-sm px-3 py-2 text-red-800">
              {error}
            </div>
          )}
          <Button
            data-testid="google-signin-btn"
            onClick={handleLogin}
            className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white rounded-sm font-semibold tracking-wide"
          >
            <LogIn className="h-4 w-4 mr-2" />
            Continue with Google
          </Button>
          <p className="text-[11px] text-slate-400 leading-relaxed text-center">
            © 2026 SR Electrosteel
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
